import { BaseService } from '../../core/BaseService';
import { DeleteData, PaginationParams } from '../../type';
import {
  AddExpenseResponse,
  ExpenseType,
  ExpenseTypeResponse,
  ExpensesRequest,
  GetExpenseTypeByIdResponse,
  GetExpenseTypeResponse,
  GetExpensesResponse,
} from './interface';

export class ExpenseProfile extends BaseService {
  async createExpenseType(req: ExpenseType) {
    return this.post<ExpenseTypeResponse, ExpenseType>(`${this.apiUrl}/api/expensetype`, req);
  }

  async getExpenseType(params: PaginationParams) {
    return this.get<GetExpenseTypeResponse>(`${this.apiUrl}/api/expensetype/paged`, params);
  }

  async updateExpenseType(req: ExpenseType) {
    return this.put<ExpenseType, ExpenseType>(`${this.apiUrl}/api/expensetype/update`, req);
  }

  async deleteEntity(id: number, typeName: string) {
    return this.delete<DeleteData>(`${this.apiUrl}/api/${typeName}/${id}`);
  }

  async getExpenseTypeById(id: number | undefined) {
    return this.get<GetExpenseTypeByIdResponse>(`${this.apiUrl}/api/expensetype/byid/${id}`);
  }

  async getExpenses(params: PaginationParams) {
    return this.get<GetExpensesResponse>(`${this.apiUrl}/api/expensemanager/paged`, params);
  }

  async addExpense(req: ExpensesRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        if (key === 'file') {
          const files = Array.isArray(value) ? value : [value];

          files.forEach((f: File) => {
            formData.append('file', f);
          });
        } else {
          formData.append(key, value);
        }
      }
    });

    return this.post<AddExpenseResponse, FormData>(`${this.apiUrl}/api/expensemanager`, formData, { headers });
  }

  async getExpensesById(id: number | undefined) {
    return this.get<AddExpenseResponse>(`${this.apiUrl}/api/expensemanager/byid/${id}`);
  }

  async updateExpense(req: ExpensesRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        if (key === 'file') {
          const files = Array.isArray(value) ? value : [value];

          files.forEach((f: File) => {
            formData.append('file', f);
          });
        } else {
          formData.append(key, value);
        }
      }
    });

    return this.put<AddExpenseResponse, FormData>(`${this.apiUrl}/api/expensemanager/update`, formData, { headers });
  }

  async deleteExpense(id: number) {
    return this.delete<DeleteData>(`${this.apiUrl}/api/expensemanager/archive/${id}`);
  }
}
